import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./tile-grid.scss";
import Tile from "../Tile/Tile";
import VideoTile from "../VideoTile/VideoTile";

const TileGrid = ({ className, children }) => {
  const classes = classnames("tile-grid", className);
  return <div className={classes}>{children}</div>;
};

TileGrid.propTypes = {
  className: PropTypes.string,
  children: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.instanceOf(Tile), PropTypes.instanceOf(VideoTile)])
  ).isRequired,
};

export default TileGrid;
